/*
 * biobio-match-hero.js
 *
 * Smooth scroll do CTA "Garantir agora" pro elemento alvo via anchor.
 * Pra anchors externos (URLs absolutas tipo /products/...), deixa o
 * comportamento default do <a href> (navega pra URL).
 *
 * Sem framework. Vanilla JS. Carregado via defer.
 */

(function () {
  const ctaButtons = document.querySelectorAll('[data-match-hero-cta]');

  for (const cta of ctaButtons) {
    cta.addEventListener('click', (e) => {
      const href = cta.getAttribute('href') || '';
      // Apenas anchors (#) sao tratados com smooth scroll
      if (!href.startsWith('#')) return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Atualiza URL sem reload pra manter o hash navegavel via back/forward
      if (history.replaceState) {
        history.replaceState(null, '', href);
      }
    });
  }
})();
